var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0598 62.6401C52.8724 62.6401 64.0698 51.4428 64.0698 37.6301C64.0698 23.8175 52.8724 12.6201 39.0598 12.6201C25.2472 12.6201 14.0498 23.8175 14.0498 37.6301C14.0498 51.4428 25.2472 62.6401 39.0598 62.6401Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 77.01C24.62 73.57 43.75 67.61 42.92 63.75C42.03 59.32 30.82 64.22 26.12 65.93",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7001 64.88C32.3401 60.63 43.9301 49.76 42.0601 47.88C39.7001 45.53 30.0601 56.02 25.2001 59.15C29.0601 54.63 39.8101 43.75 37.8101 41.95C36.9001 41.13 35.0501 41.87 32.8701 43.36C31.1381 44.5802 29.491 45.9166 27.9401 47.36C25.3151 49.7683 22.831 52.3259 20.5001 55.02C23.8801 51.09 31.3101 41.3 29.6301 39.87C27.1801 37.8 21.1601 46.08 17.3901 51.16",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 64.8599L6.49 58.8599C6.49 58.8599 16.26 39.8599 21.91 40.4199",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7198 13.71C60.7898 15.37 58.9098 15.81 53.0398 14.16C50.6798 13.5 42.1298 17.44 40.9598 15.29C39.9598 13.35 44.9598 10.65 50.6698 7.63C53.8898 5.92 54.9298 3.74 56.3998 1",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0601 39.4699C54.2701 41.2699 61.4601 36.1099 62.8801 35.0399C71.7001 28.4199 75.8801 21.2299 79.6001 10.6499",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0599 14.0898C47.6599 19.3698 38.6199 24.5598 34.6199 29.3298C34.4528 29.5288 34.3422 29.7691 34.2998 30.0254C34.2573 30.2818 34.2845 30.5449 34.3785 30.7871C34.4726 31.0294 34.63 31.2419 34.8343 31.4025C35.0386 31.563 35.2823 31.6657 35.5399 31.6998C37.2731 31.7483 38.9817 31.282 40.4499 30.3598C44.6364 28.0356 48.6174 25.3593 52.3499 22.3598C49.7999 25.2898 46.4999 27.2598 39.6499 33.0798C38.1199 34.3798 39.8999 35.6898 41.5699 35.4098C45.1899 34.7798 51.9499 30.1298 55.5699 27.3198C51.9799 31.0498 44.0599 35.1098 44.4199 37.2298C44.9799 40.8698 55.7199 34.7698 59.7199 30.9998",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKnowledge);
export default __webpack_public_path__ + "static/media/icon-knowledge.687906f55638466352bacd6fb506d65a.svg";
export { ForwardRef as ReactComponent };